export default __webpack_public_path__ + "static/media/plus.13b75358.svg";